// extracted by mini-css-extract-plugin
module.exports = {"description":"style__description__P8oiW"};